const RoutesConstants = {
  routePath: {
    precheckPage: '/',
    notFoundPage: '*',
  },
};

export default RoutesConstants;
